import React, { useState } from "react";
import { Collapse as BlueprintCollapse, Pre } from "@blueprintjs/core";
import styles from "./Collapse.module.scss";
import { Icon } from "../Icon";

export default function Collapse({ title, text = "", maxLength = 100 }) {
  const [isOpen, setIsOpen] = useState(false);
  const showCollapse = text.length > maxLength;

  const minText = () => `${text.substring(0, maxLength)}...`;

  return (
    <div className={styles.expandableView}>
      {title && <label>{title}</label>}
      <div className={styles.collapseState}>
        {!showCollapse && text}
        {showCollapse && (
          <>
            {!isOpen && minText()}
            <BlueprintCollapse isOpen={isOpen}>{text}</BlueprintCollapse>
            <Icon
              name={isOpen ? "chevron-up" : "chevron-down"}
              size={14}
              className={styles.showMore}
              onClick={() => setIsOpen(!isOpen)}
            />
          </>
        )}
      </div>
    </div>
  );
}
